import { render, staticRenderFns } from "./MaterialGroup.vue?vue&type=template&id=44060e20&"
import script from "./MaterialGroup.vue?vue&type=script&lang=js&"
export * from "./MaterialGroup.vue?vue&type=script&lang=js&"
import style0 from "./MaterialGroup.vue?vue&type=style&index=0&id=44060e20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports